module.exports = __webpack_public_path__ + "img/Chevron-left-black-fat.c26e2456.svg";